export class EventExportCriteriaDTO {}